// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakeAddressModel {
    static getAttributeTypeMap() {
        return SimpleIntakeAddressModel.attributeTypeMap;
    }
}
SimpleIntakeAddressModel.discriminator = undefined;
SimpleIntakeAddressModel.additionalProperties = false;
SimpleIntakeAddressModel.attributeTypeMap = [
    {
        "name": "addressOne",
        "baseName": "addressOne",
        "type": "string"
    },
    {
        "name": "addressTwo",
        "baseName": "addressTwo",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
];
//# sourceMappingURL=simpleIntakeAddressModel.js.map